<ami-dialog-message [setting]="message"></ami-dialog-message>
<ami-table-actions
  [settings]="table.settings"
  [data]="table.data"
  [actions]="table.actions"
  (action)="onReciveAction($event)"
></ami-table-actions>

<div *ngIf="idDocument">
  <ami-detail-dialog
    [idDocument]="idDocument"
    (onHideData)="idDocument=undefined"
  >
  </ami-detail-dialog>
</div>


<ng-container *ngIf="cancelCreditNoteDialog === true">
  <pg-cancel-credit-note-dialog
    (close)="cancelCreditNoteDialog = false"
    [idToCancel]="idDocumentToCancel"
  ></pg-cancel-credit-note-dialog>
</ng-container>
